module.exports = "/_next/static/images/cd-b070cb89ccbea5077acc3acab5b57d50.svg";